import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Form, Button, InputGroup, Alert } from 'react-bootstrap';
import PhoneInput from '../Input/PhoneInput';
import RenderizarProduto from '../Utils/RenderizarProduto';
import Swal from 'sweetalert2';


const Feedback = ({ crud, empresa, storage }) => {
  const { get, loading, post } = crud;
  const [feedback, setFeedback] = useState(null);
  const [perguntas, setPerguntas] = useState([]);
  const [telefone, setTelefone] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const navigate = useNavigate();
  
  const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        }
  });

  useEffect(() => {
    const buscarPerguntas = async () => {
      try {
        const response = await get(`/feedback/perguntas/?empresa_geral_id=${empresa?.id}`, 'pagina');
        if (response && response.length) {
          setPerguntas(response[0].results);
        }
      } catch (err) {}
    };
    buscarPerguntas();
  }, []);
  
  const enviarFeedback = async()=>{
    const errors = {};
    if(!feedback?.anonimo){
      if(!feedback?.nome) errors.nome="Nome é obrigatório"
      if(!telefone) errors.telefone="Telefone é obrigatório"
    }

    try{
      let lista = [];
      perguntas.forEach(item => {
        lista.push({
          'resposta': item.resposta,
          'pergunta': item.id
        });
        if(!item.resposta){
          errors.apiError="Todas as respostas são obrigatórias";
        }
      });
      if (Object.keys(errors).length > 0) {
          setFormErrors(errors);
          return;
      }
      setFormErrors({});
      const feedData = {
        "empresa": empresa?.id,
        "feedback_respostas":lista,
        "anonimo": feedback?.anonimo,
        "nome": feedback?.anonimo?null:feedback?.nome,
        "telefone": feedback?.anonimo?null:telefone
      }
      const response = await post(feedData, `/feedback/feedbacks/`);
      if(response && response.length){
        navigate("?");
        Toast.fire({
            icon: "success",
            title: `Obrigado pelo feedback`
        });
      }
    }catch(err){
      validarErrosApi(err);
    }
  }
  
  const validarErrosApi = (err) => {
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar alterações.' 
            : err.response?.data?.detail;

        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
            empresa: err.response?.data?.empresa,
            nome: err.response?.data?.nome,
            telefone: err.response?.data?.telefone,
        }));
  };

  return (
    <>
      <RenderizarProduto
        key={empresa?.id}
        src={empresa?.logomarca}
        titulo={empresa?.nome_da_loja}
        text2={empresa?.descricao}
        />
      <div className="fs-5 mt-3">
        Estou sempre buscando evoluir e sua opinião é muito importante. Você poderia responder essas perguntinhas rápidas?
      </div>
      {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}

      <Form.Group controlId="formEnvioWhatsApp" className="mt-3">
        <Form.Check
          type="switch"
          label="Responder Anônimo"
          checked={feedback?.anonimo}
          onChange={(e) =>
            setFeedback((prevItem) => ({
              ...prevItem,
              anonimo: e.target.checked,
            }))
          }
        />
      </Form.Group>

      {!feedback?.anonimo && (
        <>
          <Form.Group controlId="formNome" className="mt-3">
            <InputGroup>
              <span className="input-group-text">Nome *</span>
              <Form.Control
                type="text"
                value={feedback?.nome}
                onChange={(e) =>
                  setFeedback((prevItem) => ({
                    ...prevItem,
                    nome: e.target.value,
                  }))
                }
              />
            </InputGroup>
            {formErrors.nome && <Alert variant="danger">{formErrors.nome}</Alert>}
          </Form.Group>

          <PhoneInput phone={telefone} setPhone={setTelefone} formErrors={formErrors} is_obrigatorio={true} label={"WhatsApp"} />
        </>
      )}

      <div className="list-group mt-3">
        {perguntas.length > 0 ? (
          perguntas.map((x, index) => (
            <div key={x.id} data-aos="fade-up" data-aos-delay={parseInt(`${index}00`)}>
              <RenderizarProduto
                col="d-none"
                lm="mb-1"
                text1={x.pergunta}
                extra={
                  <>
                    {x.tipo === 'texto' && (
                      <Form.Group controlId={`form_${x.id}`} className="mt-3">
                        <InputGroup>
                          <Form.Control
                            as="textarea"
                            value={x.resposta}
                            onChange={(e) => {
                              const valor = e.target.value;
                              setPerguntas((prev) =>
                                prev.map((item, i) => (i === index ? { ...item, resposta: valor } : item))
                              );
                            }}
                          />
                        </InputGroup>
                      </Form.Group>
                    )}

                    {x.tipo === 'simnao' && (
                      <Form.Group controlId={`form_${x.id}`} className="mt-3" >
                        <InputGroup>
                          <Button variant={`${x.resposta==="Sim"?"":"outline-"}secondary`} className="px-4" onClick={()=>{
                            setPerguntas((prev) =>
                                prev.map((item, i) => (i === index ? { ...item, resposta: "Sim" } : item))
                            );
                          }}>Sim</Button>
                          <Button variant={`${(x.resposta||`Sim`)==="Sim"?"outline-":""}secondary`} className="px-4" onClick={()=>{
                            setPerguntas((prev) =>
                                prev.map((item, i) => (i === index ? { ...item, resposta: "Não" } : item))
                            );
                          }}>Não</Button>
                        </InputGroup>
                      </Form.Group>
                    )}

                    {x.tipo === 'nota' && (
                      <Form.Group controlId={`form_${x.id}`} className="mt-3">
                        <InputGroup>
                          <span className="input-group-text">Nota *</span>
                          <Form.Control
                            type="number"
                            value={x.resposta}
                            onChange={(e) => {
                              const valor = !e.target.value
                                ? e.target.value
                                : parseInt(e.target.value || 0) < 0
                                ? 0
                                : parseInt(e.target.value || 0) > 10
                                ? 10
                                : parseInt(e.target.value || 0);
                              setPerguntas((prev) =>
                                prev.map((item, i) => (i === index ? { ...item, resposta: valor } : item))
                              );
                            }}
                          />
                        </InputGroup>
                      </Form.Group>
                    )}
                  </>
                }
              />
            </div>
          ))
        ) : (
          !loading && <p data-aos="fade-up" className="text-center text-muted">Nenhuma pergunta encontrada.</p>
        )}
      </div>
      
      
      <Button variant="secondary" onClick={enviarFeedback} className="w-100 my-4">Enviar Feedback</Button>

    </>
  );
};

export default Feedback;